
import { FilterableMultiSelect, Toggle } from "carbon-components-react"
import { useEffect,  useState } from "react"
import {  g100 } from '@carbon/themes';
import {groupBy}  from "lodash"


const slugify = (stringValue) => {
    return stringValue
        .normalize('NFD') // split an accented letter in the base letter and the acent
        .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
        .replace(/\s+/g, '_') // separator
}


const MapControls = ({
    allItems,
    filters,
    setFilters,
    toggleIcons
}) => {

    const [selectedItemsByPatente,setSelectedItemsByPatente] = useState([])
    const [selectedItemsByState,setSelectedItemsByState] = useState([])
    const [selectedItemsByType,setSelectedItemsByType] = useState([])

    useEffect(()=> {
        setFilters({
            patentes : selectedItemsByPatente.map(d => d.text),
            time_categories: selectedItemsByState.map(d => d.text),
            types: selectedItemsByType.map(d => d.text)
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[
        selectedItemsByPatente,selectedItemsByState,selectedItemsByType
    ]
)



    return (
        <div style={{
            display:"flex",
            flexDirection: "row",
            width:"98%",
            backgroundColor:g100.background,
            alignItems: "center",
            color:g100.color}}>    
        {(allItems && allItems?.length > 0) ?
        <>
            <FilterableMultiSelect 
            id="multi-patente"
            direction="top"
            style={{
                backgroundColor: g100.background,
                border: `1px ${g100.borderStrong03}`

            }}
            autoAlign={true}
            label="" 
            titleText="Patente"
            type="inline"
            onChange={({selectedItems}) => setSelectedItemsByPatente(() => selectedItems)}             
            items={allItems?.map(d => ({
                    text: String(d.properties.truckPatent),
                    lahel: String(d.properties.truckPatent)
                })
            )}
            itemToString={item => item ? item.text : ''} 
            selectionFeedback="top-after-reopen"
            
             /> 
             <FilterableMultiSelect 
             id="multi-state"
            style={{
                backgroundColor: g100.background,
                border: `1px ${g100.borderStrong03}`
            }}
            label="" 
            type="inline"
            titleText="Estado"             
            items={Object.keys(groupBy(allItems,"properties.time_category")).map(d => ({
                text: d,
                label: slugify(d)
            }))}
            onChange={({selectedItems}) => setSelectedItemsByState(() => selectedItems)}
            itemToString={item => item ? item.text : ''} 
            selectionFeedback="top-after-reopen"
             /> 


            <FilterableMultiSelect 
            autoAlign={true}
            style={{
                backgroundColor: g100.background,
                border: `1px ${g100.borderStrong03}`

            }}
            direction="top"
            id="multi-tipo"
            label="" 
            type="inline"
            titleText="Tipo de Vehiculo"             
            items={Object.keys(groupBy(allItems,"properties.type")).map(d => ({
                    text: d,
                    label: slugify(d)
                }))}
            
            
            // .map((d)=> ({
            //     text: d,
            //     label: slugify(d)
            // }))
            onChange={({selectedItems}) => setSelectedItemsByType(() => selectedItems)}
            itemToString={item => item ? item.text : ''} 
            // selectedItems={selectedItemsByType}
            selectionFeedback="top-after-reopen"
             /> 
            <Toggle 
                labelText="Mostrar Iconos" 
                labelA="Off" 
                labelB="On" 
                defaultToggled 
                id="toggle-1" 
                hideLabel 
                style={{
                height: "75%",
                }}
                onToggle={toggleIcons}
            />

        </>
        
            : null }
        
  
   
        </div>
    )
}


export default MapControls